import * as Lambda from '../../services/LambdaApi';
import { AddSignOutAnswerPayload, SignOutQuestionsRecord } from '../types/SignOutQuestions';

/**
 * The facility's sign-out questions (null when staff haven't set any up). The same questions the
 * room device asks when a resident signs out. Amplify sends `enabledOnly: true` as `?enabledOnly=true`.
 */
const getSignOutQuestions = async (facilityId: string): Promise<SignOutQuestionsRecord | null> => {
    try {
        const apiPath = `/s2l/${facilityId}/getSignOutQuestions`;
        const params = { queryStringParameters: { Facility: facilityId, enabledOnly: true } };
        const response = await Lambda.Get(apiPath, params, 'lambda');
        if (!response?.Result?.Success) {
            throw new Error(response?.Result?.Error || 'Error fetching sign-out questions');
        }
        const content = response.Result.Content as { Result?: SignOutQuestionsRecord[] };
        return content?.Result?.[0] ?? null;
    } catch (err) {
        console.error('[getSignOutQuestions] Failed to fetch sign-out questions', { facilityId, err });
        throw new Error(err instanceof Error ? err.message : 'Error fetching sign-out questions');
    }
};

/**
 * Saves a resident's answers. The backend requires an answer for every enabled question and none
 * for a disabled one, and stamps the time and room itself.
 */
const addSignOutAnswer = async (facilityId: string, payload: AddSignOutAnswerPayload) => {
    try {
        const apiPath = `/s2l/${facilityId}/addSignOutAnswer`;
        const response = await Lambda.Post(apiPath, payload, 'lambda');
        if (!response?.Result?.Success) {
            throw new Error(response?.Result?.Error || 'Error saving sign-out answers');
        }
    } catch (err) {
        console.error('[addSignOutAnswer] Failed to save sign-out answers', { facilityId, residentId: payload.residentId, err });
        throw new Error(err instanceof Error ? err.message : 'Error saving sign-out answers');
    }
};

export { getSignOutQuestions, addSignOutAnswer };
